import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import VcOpsLogo from 'components/VcOpsLogo/VcOpsLogo';

const useStyles = makeStyles({
  title: {
    fontSize: '3rem',
    fontWeight: 'bold',
    marginBottom: '2rem',
    '@media (max-width: 768px)': {
      fontSize: '2.5rem',
    },
  },
  subTitle: {
    fontSize: '1.75rem',
    marginTop: '0',
    marginBottom: '8px',
  },
});

export default function MaintenanceMode() {
  const classes = useStyles();

  return (
    <div
      className="d-flex flex-column justify-content-center align-items-center w-100"
      style={{
        maxWidth: 1200,
        height: '100vh',
        margin: '0 auto',
      }}
    >
      <div>
        <VcOpsLogo style={{ maxWidth: 300 }} />
      </div>
      <h1 className={classes.title}>Maintenance Mode</h1>
      <p className={classes.subTitle}>Please check back soon.</p>
    </div>
  );
}
